import { render, staticRenderFns } from "./SlagMeltingPointList.vue?vue&type=template&id=54aa5846&"
import script from "./SlagMeltingPointList.vue?vue&type=script&lang=js&"
export * from "./SlagMeltingPointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports